import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MaterialModule} from '@shared/material.module';

/**
 * Composant pour afficher un état vide de manière professionnelle
 */
@Component({
  selector: 'empty-state',
  standalone: true,
  imports: [CommonModule, MaterialModule],
  templateUrl: './empty-state.component.html',
  styleUrl: './empty-state.component.scss'
})
export class EmptyStateComponent {
  @Input() icon: string = 'inbox';
  @Input() title: string = 'Aucune donnée';
  @Input() message: string = 'Il n\'y a rien à afficher pour le moment';
  @Input() actionLabel?: string;
  @Input() showAction: boolean = false;
}
